<template>
  <div class="attach">
    <div class="attach__head">Прикрепите файлы :</div>

    <div class="attach__all-items">
      <div class="attach__item attach__sub-item" v-for="(file, index) in files" :key="index">
        <div class="attach__name">{{file.name}}</div>
      </div>
    </div>

    <div class="attach__item">
      <label for="files" class="attach__up">Загрузить файл</label>
      <input id="files" class="attach__input browser-default" type="file" name="files[]" multiple @change="onFilesInputChange" ref="inputFiles">
    </div>
  </div>
</template>

<script>
export default {
  anotherNameLife: "UploadFiles",
  data(){
    return {
      files: [],
    };
  },
  methods: {
    onFilesInputChange(event){
      this.files = event.target.files;
    },
  }
}
</script>

<style scoped>
.attach {
  margin-bottom:20px;
}
.attach__head {
  padding: 0 0 5px 0;
  margin: 0 0 5px 0;
  font-family: Source Sans Pro,Open Sans,sans-serif;
  font-size: 14px;

}
.attach__item {
  border-bottom: #ccc solid 1px;
  padding: 0 0 5px 0;
  margin: 0 0 5px 0;
}

.attach__item:last-of-type {
  margin-bottom: 0;
  border-bottom: none;
}

.attach__up {
  cursor: pointer;
  border: 1px solid grey;
  font-family: Source Sans Pro,Open Sans,sans-serif;
  font-size: 18px;
  font-weight: bold;
  max-width: 170px;
  text-align: center;
}

.attach__edit,
.attach__delete {
  margin-right: 10px;
  cursor: pointer;
}

.attach__edit {
  color: #182E7A;
}

.attach__delete {
  color: #E60028;
  font-size:12px;
}

.attach__item--attached .attach__up {
  display: none;
}

.attach__item--attached .attach__edit,
.attach__item--attached .attach__delete {
  display: inline-block;
}

.attach__input {
  display: none;
}
.attach__name {
  float: left;
  margin-right: 9px;
}

.attach__all-items{
  display: flex;
  flex-direction: column;
}

.attach__sub-item{
  display: flex;
  justify-content: space-between;
}
</style>